import { toast } from "react-toastify";
import {
  fetchEditCategoryFailure,
  fetchEditCategorySuccess,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import { UPDATE_CATEGORY } from "../../constants/constants";

export const editCategory =
  (jsonObj, categoryId, setLoading, callBack = () => {}) =>
  async (dispatch) => {
    setLoading(true);

    await determineBaseUrlAndPerformApiCall(
      UPDATE_CATEGORY(categoryId), 
      "PUT",
      jsonObj
    )
      .then((response) => {
        if (response.error) {
          dispatch(fetchEditCategoryFailure(response.error.message));
          toast.error(response.error.message);
          callBack();
        } else {
          dispatch(fetchEditCategorySuccess(response));
          dispatch(setSuccessMessage(true));
          callBack();
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };